import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const KeyIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 19L16 19L16 15L13.32 15C12.18 17.42 9.72 19 7 19C3.14 19 0 15.86 0 12S3.14 5 7 5C9.72 5 12.17 6.58 13.32 9L24 9L24 15L22 15L22 19ZM18 17L20 17L20 13L22 13L22 11L11.94 11L11.71 10.33C11.01 8.34 9.11 7 7 7C4.24 7 2 9.24 2 12S4.24 17 7 17C9.11 17 11.01 15.66 11.71 13.67L11.94 13L18 13L18 17ZM7 15C5.35 15 4 13.65 4 12S5.35 9 7 9S10 10.35 10 12S8.65 15 7 15ZM7 11C6.45 11 6 11.45 6 12S6.45 13 7 13S8 12.55 8 12S7.55 11 7 11Z"
      fill="currentColor"
    />
  </svg>
);

KeyIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(KeyIcon);
